/**
 * Форматирует число в ру-локали
 * @param value - число
 * @param maximumFractionDigits - максимум знаков после запятой (по умолчанию 0)
 * @returns отформатированная строка
 */
export const formatDecimal = (value: number, maximumFractionDigits = 0): string =>
  Intl.NumberFormat('ru-RU', { maximumFractionDigits }).format(value);

/**
 * Форматирует долю или процент со знаком «%»
 * @param value - значение в процентах (не доля)
 * @param maximumFractionDigits - максимум знаков после запятой (по умолчанию 1)
 * @returns отформатированная строка или "—" для null/undefined
 */
export const formatPercent = (value: number | null | undefined, maximumFractionDigits = 1): string => {
  if (value === null || value === undefined) {
    return '—';
  }

  return `${formatDecimal(value, maximumFractionDigits)}%`;
};

/**
 * Форматирует сумму в рубли
 * @param amount - сумма в копейках
 * @param options.trimZeroKopecks - «1 500 ₽» вместо «1 500,00 ₽», копейки только если они есть
 * @returns отформатированная строка с валютой
 */
export const formatMoney = (
  amount: number | null | undefined,
  { trimZeroKopecks = false }: { trimZeroKopecks?: boolean } = {},
): string | undefined => {
  if (amount === null || amount === undefined) {
    return;
  }

  // Принимаем сумму в копейках
  return Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    ...(trimZeroKopecks && amount % 100 === 0 ? { minimumFractionDigits: 0 } : {}),
  }).format(amount / 100);
};
